/* Pufa capsule pick (snippets/pufa-capsule-pick.liquid).
   Pure decisions (initialView, canAutoOpen) are exported for node tests/pufa-capsule-pick.test.js;
   in the browser the same file wires the DOM. */
(function () {
  'use strict';
  var KEY = 'pufa_capsule_v1';        // {stage:'won'|'claimed', closedAt:ms, views:n, subscribed:bool}
  var LEGACY_KEY = 'pufa_spin_v1';    // the old wheel: {won:true} means this visitor already has the capsule
  var DAY = 24 * 60 * 60 * 1000;

  // 'hidden' = never show again, 'claim' = won but no email yet, 'game' = fresh visitor
  function initialView(state, legacy) {
    if ((state && state.stage === 'claimed') || (legacy && legacy.won)) return 'hidden';
    if (state && state.stage === 'won') return 'claim';
    return 'game';
  }

  // Automatic opening only for fresh visitors who did not close it in the last day, never on cart/checkout.
  function canAutoOpen(state, now, path) {
    if (initialView(state, null) !== 'game') return false;
    if (state && state.closedAt && now - state.closedAt < DAY) return false;
    return !/\/(cart|checkouts?)(\/|$)/.test(path) && !/^\/pages\/track(\/|$)/.test(path);
  }

  // Shopify redirects a saved customer form to the same page with ?customer_posted=true.
  function signupConfirmed(url) { return /[?&]customer_posted=true(&|#|$)/.test(url || ''); }

  // Own the submit event so Shopify's handler cannot start a second verification.
  // protect's callback only confirms readiness; protected form.submit() still verifies CAPTCHA.
  function wireSignup(form, protect, status, record) {
    var input = form.querySelector('input[type=email]'), button = form.querySelector('button');
    var ready = false, preparing = false, pending = false, sent = false, posting = false, timer;
    function busy(on) {
      input.readOnly = on;
      button.disabled = on;
      button.classList.toggle('is-loading', on);
      button.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    function fail() {
      clearTimeout(timer);
      pending = false; sent = false; preparing = false;
      busy(false); status('error'); record('error');
    }
    function watch() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!pending) return;
        if (!sent) { fail(); return; }
        // Verification can still finish. Keep this attempt locked instead of starting another.
        status('slow'); record('slow');
      }, 12000);
    }
    function send() {
      if (!pending || sent) return;
      sent = true;
      status('verifying'); record('verifying');
      try { form.submit(); } catch (e) { fail(); }
    }
    function prepare() {
      if (ready || preparing) return;
      preparing = true;
      try {
        protect(function () {
          ready = true; preparing = false;
          if (pending) send();
        });
      } catch (e) { if (pending) fail(); else preparing = false; }
    }
    function reset() {
      clearTimeout(timer);
      pending = false; sent = false;
      busy(false); status('idle');
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (pending) return;
      pending = true; sent = false; posting = false;
      busy(true); status('preparing'); record('start');
      watch();
      if (ready) send(); else prepare();
    }, true);
    form.addEventListener('formdata', function (e) {
      if (pending && !posting && e.formData.get('h-captcha-response')) {
        posting = true;
        status('posting'); record('posting');
        watch();
      }
    });
    return { prepare: prepare, reset: reset };
  }

  var api = { initialView: initialView, canAutoOpen: canAutoOpen, signupConfirmed: signupConfirmed, wireSignup: wireSignup };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }

  function load(k) { try { return JSON.parse(localStorage.getItem(k)) || {}; } catch (e) { return {}; } }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function update(patch) { var s = load(KEY); for (var p in patch) s[p] = patch[p]; save(s); return s; }
  // Same sinks as the wizard's track() (pufa_wizard) and the quiz's (pufa_quiz): dataLayer, Meta, Shopify customer events, DOM.
  function track(action, extra) {
    var detail = Object.assign({ action: action }, extra || {});
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'pufa_capsule' }, detail)); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'pufa_capsule_' + action, detail); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('pufa_capsule', detail); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('pufa:capsule', { detail: detail })); } catch (e) {}
  }
  // Keep timings for this tab only. Never store the address or CAPTCHA response.
  function recordSignup(phase) {
    var elapsed = 0;
    try {
      var key = 'pufa_capsule_signup', entries = phase === 'start' ? [] : JSON.parse(sessionStorage.getItem(key) || '[]');
      var now = Date.now();
      elapsed = entries.length ? now - entries[0].at : 0;
      entries.push({ phase: phase, at: now, elapsed_ms: elapsed });
      sessionStorage.setItem(key, JSON.stringify(entries.slice(-12)));
    } catch (e) {}
    track('signup_phase', { phase: phase, elapsed_ms: elapsed });
  }
  // The win is live the moment Shopify saves the sign-up, not only after a button tap (pufa-gift-capsule.js keeps the 7-day clock).
  function armGift() {
    if (window.PufaGift && PufaGift.arm) { PufaGift.arm(); return; }
    try { if (!localStorage.getItem('pufa_gift_capsule')) localStorage.setItem('pufa_gift_capsule', String(Date.now())); } catch (e) {}
  }

  var el = document.getElementById('pufa-cp');
  if (!el) return;
  if (/^\/pages\/track(\/|$)/.test(location.pathname)) return;   // shoppers checking a parcel: no popup, no teaser

  // ?spin=reset clears this browser's state and opens, ?spin=1 just opens (tests, ads, emails)
  // Back from Shopify after our form saved the sign-up: show "saved", ignore ?spin= still in the URL
  var justSaved = signupConfirmed(location.href) && location.hash === '#pufa-cp-form';
  var param = justSaved ? null : new URLSearchParams(location.search).get('spin');
  if (param === 'reset') { try { localStorage.removeItem(KEY); localStorage.removeItem(LEGACY_KEY); } catch (e) {} }
  var state = update({ views: (load(KEY).views || 0) + 1 });
  if (justSaved) { state = update({ stage: 'claimed', subscribed: true }); armGift(); track('saved'); recordSignup('saved'); }
  if (initialView(state, load(LEGACY_KEY)) === 'hidden' && !justSaved) return;
  el.hidden = false;
  setTimeout(function () {
    if (document.querySelector('#preview-bar-iframe, #PBarNextFrameWrapper')) el.classList.add('pufa-cp--preview');
  }, 1500);

  function $(s) { return el.querySelector(s); }
  var teaser = $('[data-cp-open]'), teaserText = $('[data-cp-teaser-text]');
  var overlay = $('.pufa-cp__overlay'), modal = $('.pufa-cp__modal'), card = $('.pufa-cp__card');
  var stage = $('[data-cp-stage]'), hint = $('[data-cp-hint]');
  var caps = [].slice.call(stage.querySelectorAll('.pufa-cp__cap'));
  var form = $('#pufa-cp-form'), email = form.querySelector('input[type=email]');
  var error = $('[data-cp-error]'), signupStatus = $('[data-cp-status]'), retry = $('[data-cp-retry]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var onTouch = window.matchMedia('(hover: none)').matches;
  var WAITING = 'הקפסולה שלך מחכה 🎁';
  var opened = false, autoDone = false, played = false, armed = false, timers = [];

  if (state.stage === 'won') teaserText.textContent = WAITING;

  function show(name) {
    el.querySelectorAll('[data-view]').forEach(function (v) { v.hidden = v.getAttribute('data-view') !== name; });
  }
  function focusEmail() { (onTouch ? card : email).focus({ preventScroll: true }); }  // phones: keep focus in the dialog, no keyboard jump

  function ready() {
    armed = true;
    caps.forEach(function (c) { c.disabled = false; });
    hint.textContent = 'בחרו קפסולה 👆';
  }

  // 6 swaps of two slots, 300ms each. Offsets are measured, so RTL order and screen width do not matter.
  function shuffle() {
    var slots = caps.map(function (c) { return c.getBoundingClientRect().left; });
    var pos = [0, 1, 2], k = 0;
    var t = setInterval(function () {
      var a = k % 3, b = (k + 1) % 3, tmp = pos[a];
      pos[a] = pos[b]; pos[b] = tmp;
      caps.forEach(function (c, i) { c.style.transform = 'translateX(' + (slots[pos[i]] - slots[i]) + 'px)'; });
      if (++k >= 6) { clearInterval(t); timers.push(setTimeout(ready, 350)); }
    }, 300);
    timers.push(t);
  }

  function play() {
    played = true;
    show('game');
    if (reduced) { ready(); return; }
    timers.push(setTimeout(shuffle, 750));   // after the drop-in bounce
  }

  function pick(cap) {
    if (!armed) return;
    armed = false;
    update({ stage: 'won' });   // saved first, so a reload lands on the claim step instead of a replay
    track('pick', { slot: caps.indexOf(cap) + 1 });
    hint.textContent = '';
    caps.forEach(function (c) { c.disabled = true; if (c !== cap) c.classList.add('is-dim'); });
    cap.classList.add('is-shake');
    setTimeout(function () {
      cap.classList.add('is-open');
      if (opened && window.PufaEmoji) window.PufaEmoji.burst(cap.getBoundingClientRect(), { count: 6, glyphs: ['🎁', '✨', '💎', '🥳'] });
    }, reduced ? 0 : 550);
    setTimeout(function () { show('claim'); focusEmail(); track('claim_view'); }, reduced ? 0 : 2100);
  }
  caps.forEach(function (c) { c.addEventListener('click', function () { pick(c); }); });

  function open(src) {
    if (opened) return;
    opened = true; autoDone = true;
    signup.prepare();
    track('open', { trigger: typeof src === 'string' ? src : 'teaser' });
    overlay.hidden = false; modal.hidden = false; teaser.hidden = true;
    document.body.classList.add('pufa-cp-open');
    var stageNow = load(KEY).stage;
    if (stageNow === 'claimed') { show('done'); card.focus({ preventScroll: true }); return; }
    if (stageNow === 'won') { show('claim'); focusEmail(); return; }
    if (!played) play();
    card.focus({ preventScroll: true });
  }

  function close() {
    overlay.hidden = true; modal.hidden = true; opened = false;
    document.body.classList.remove('pufa-cp-open');
    var s = load(KEY);
    track('close', { stage: s.stage || (armed ? 'pick' : 'shuffle') });
    if (!s.stage && !armed) {   // closed before the shuffle finished: reset so the next open replays it
      timers.forEach(clearTimeout); timers = [];
      caps.forEach(function (c) { c.style.transform = ''; });
      played = false;
    }
    if (s.stage === 'claimed') { el.hidden = true; return; }   // done: the teaser is gone for good
    teaser.hidden = false;
    if (s.stage === 'won') teaserText.textContent = WAITING;
    else update({ closedAt: Date.now() });
    teaser.focus({ preventScroll: true });
  }
  el.querySelectorAll('[data-cp-open]').forEach(function (b) { b.addEventListener('click', open); });
  el.querySelectorAll('[data-cp-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close(); });

  // Load only when opened. Shopify owns verification and the native POST/redirect.
  function protectForm(done) {
    if (window.Shopify && Shopify.captcha) Shopify.captcha.protect(form, done);
    else done();
  }
  var signup = wireSignup(form, protectForm, function (phase) {
    var messages = {
      preparing: 'מכינים את ההרשמה המאובטחת...',
      verifying: 'בודקים את ההרשמה שלך...',
      posting: 'שומרים לך את הקפסולה...',
      slow: 'זה לוקח יותר מהרגיל. אפשר להמתין, או לרענן ולנסות שוב.'
    };
    error.hidden = phase !== 'error';
    signupStatus.hidden = !messages[phase];
    signupStatus.textContent = messages[phase] || '';
    retry.hidden = phase !== 'slow' && phase !== 'error';
  }, function (phase) {
    if (phase === 'start') track('submit');
    recordSignup(phase);
  });
  retry.addEventListener('click', function () { location.reload(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) signup.reset(); });

  // Auto-open: 3rd page view, 50s, desktop exit intent. No scroll trigger: it fired mid-decision on product pages.
  if (param === '1' || param === 'reset') setTimeout(function () { open('link'); }, 600);
  if (justSaved) setTimeout(function () { open('saved'); }, 300);
  if (canAutoOpen(state, Date.now(), location.pathname)) {
    var auto = function () {
      if (autoDone) return;
      // Never cover a flow she is in the middle of (quiz / order wizard): try again once it is closed.
      if (document.querySelector('.pufa-quiz.is-open, .owz-overlay.is-open')) { setTimeout(auto, 8000); return; }
      open('auto');
    };
    if (state.views >= 3) setTimeout(auto, 1500);
    setTimeout(auto, 50000);
    if (!onTouch) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) auto(); });
  }
})();
